import { Impacts, State, SubmitForm } from '@/views/events/submodules/events-detail.types';
import { useGenerateImpactsList }     from '@/views/events/submodules/hooks/use-event-detail-form.hook';

export default {
  setImpactsList(state: State, dateRange: Array<Date> | null): void {
    state.form.impacts = dateRange ? useGenerateImpactsList(dateRange) : [];
  },

  setMassImpact(state: State, massImpact: string | null): void {
    if (massImpact && state.form.impacts.length) {
      state.form.impacts = state.form.impacts.map((impact: Impacts) => ({
        day: impact.day,
        value: massImpact,
      }));
    }
  },

  setOneEvent(state: State, payload: { data: SubmitForm; eventUuid: string }): void {
    const { startDate, endDate, impacts, internal, ...others } = payload.data;

    state.switch.internal = internal;
    Object.assign(state.form, {
      ...others,
      impacts: useGenerateImpactsList([ startDate, endDate ], impacts),
      dateRange: [ new Date(startDate), new Date(endDate) ],
      uuid: payload.eventUuid,
    });
  },

  setLoading(state: State, payload: boolean): void {
    state.loading = payload;
  },
};
